import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/js/utils";

export default (wireModel, withoutRefresh, maskPhone=false, initialCountry = 'us') => ({
    wireModel,
    maskPhone,
    intl: null,
    withoutRefresh,
    changed: false,
    initialCountry,

    init() {
        const input = this.$refs.phone;
        this.$nextTick(() => {
            this.intl = intlTelInput(input, {
                initialCountry: this.initialCountry,
                separateDialCode: true,
                formatOnDisplay: true,
                utilsScript: "intl-tel-input/build/js/utils",
                customContainer: "w-full"
            });

            this.setValue();
            this.addListeners();

            this.$watch('maskPhone', () => this.applyMask());
            this.$watch('wireModel', (value) => {
                if (!value) {
                    this.intl.setNumber('');
                }
            });
        });
    },

    setValue() {
        if(this.wireModel && !this.wireModel.includes('+')) {
            this.changeModel(`+${this.wireModel}`);
        }

        this.intl.setNumber(this.wireModel ?? '');
        this.applyMask();
    },

    addListeners() {
        const input = this.$refs.phone;
        input.addEventListener("keyup", () => {
            this.formatIntlTelInput();
            if (!this.maskPhone) {
                this.changeModel(this.intl.getNumber());
            }
        });
        input.addEventListener("input", () => this.formatIntlTelInput());

        if (this.maskPhone) {
            return;
        }

        input.addEventListener("blur", () => this.changeModel(this.intl.getNumber()));
        input.addEventListener("keydown", () => this.changeModel(this.intl.getNumber()));
        input.addEventListener("countrychange", ({ target }) => {
            this.$dispatch('selected-country', [this.intl.defaultCountry]);

            if (!this.withoutRefresh) {
                target.value = '';
                this.changeModel(target.value);
            }
        });
    },

    applyMask() {
        if(!this.maskPhone) {
            return;
        }

        const phone = this.intl.telInput.value;
        const lastTwoDigits = phone.slice(-2);

        this.intl.telInput.disabled = true;
        this.intl.telInput.value = phone.replace(/\d/g, 'X').slice(0, -2) + lastTwoDigits;
    },

    formatIntlTelInput() {
        if (typeof intlTelInputUtils !== "undefined") {
            let currentText = this.intl.getNumber(
                intlTelInputUtils.numberFormat.INTERNATIONAL
            );

            if (typeof currentText === "string") {
                this.intl.setNumber(currentText);
            }
        }
    },

    changeModel(value) {
        if(this.maskPhone ||this.$refs.phone.disabled || this.wireModel === value) {
            return;
        }

        this.wireModel = value;
    },
});
